/*eslint no-unused-vars: "error"*/
/*exported swiper*/

import './module/_multi_Korrektur.js';
import './module/pdfjs_redactor.js';

import 'magnific-popup';
// import './module/holz_magnificPopup.js';y
import './module/magnificPopup_universal.js';
import './module/holzpreis_popup_info.js';

import '../../node_modules/shariff/dist/shariff.min.js';
// import '../../node_modules/shariff/src/js/shariff.min.js';


// var Shariff = require('shariff');
// var $ = require('jquery');
// var buttonsContainer = $('.shariff');
// new Shariff(buttonsContainer, {
//     orientation: 'vertical'
// });



import './module/modul_accordion2.js';
import './module/modul_tab.js';
import './module/modul_form.js';

import './module/holzpreis_syncdata.js';


// codekit-append "../../node_modules/filepond-plugin-file-poster/dist/filepond-plugin-file-poster.js";

import FlexMasonry from '../../node_modules/flexmasonry/src/flexmasonry.js';

FlexMasonry.init('.flexmasonry', {
    responsive: true,
    breakpointCols: {
        // 'min-width: 1500px': 6,
        // 'min-width: 1200px': 5,
        // 'min-width: 992px': 4,
        // 'min-width: 768px': 3,
        // 'min-width: 576px': 2,

        'min-width: 1400px': 3,
        'min-width: 700px': 2
    },
    numCols: 2
});


// FIX the flicker beim Laden
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(flexmasonry_visible, 450);
});

function flexmasonry_visible() {
    const flexmasonry_wrappers = document.querySelectorAll(".flexmasonry_wrapper");
    for (var a = 0; a < flexmasonry_wrappers.length; a++) {
        flexmasonry_wrappers[a].classList.remove('is-invisible');
    }
}




// SPLIDE ****************************//

import Splide from '@splidejs/splide';
import {
    Intersection
} from '@splidejs/splide-extension-intersection';


const classExists_slide = document.getElementsByClassName('splide').length > 0;
if (classExists_slide) {
    var splide = new Splide('.splide', {
        type: 'loop',
        // height     : '9rem',
        perPage: 3,
        gap: '1rem',
        speed: 600,
        classes: {
            arrows: 'splide__arrows your-class-arrows',
            arrow: 'splide__arrow your-class-arrow',
            prev: 'splide__arrow--prev slider__footer_prev',
            next: 'splide__arrow--next slider__footer_next'
        },
        breakpoints: {
            1024: {
                perPage: 2
                // ,height: '33rem'
            },
            699: {
                perPage: 1
                // ,height: '22rem'
            }
        },
        autoplay: 'pause',
        intersection: {
            inView: {
                autoplay: true
            },
            outView: {
                autoplay: false
            }
        }
    });


    splide.mount({
        Intersection
    });
}



// new Splide( '.splide' ).mount();

// var elms = document.getElementsByClassName('splide');
// for (var i = 0; i < elms.length; i++) {
//   new Splide(elms[i ]).mount();
// }


// MIXITUP ****************************//

import mixitup from 'mixitup';
// var mixer = mixitup('.gallery_odb');
// var mixer = mixitup(containerEl);


// var mixer = mixitup(containerEl);

var gallery_odb = document.getElementById("gallery_odb");
if (gallery_odb) {
    var mixer = mixitup('.gallery_odb', {
        selectors: {
            target: '.multi_grid__item'
        },
        animation: {
            // duration: 300
            // effectsOut: 'fade translateY(-100%)'
            // enable: false
        }
    });
    
    mixer.filter('all');
}

















// // core version + navigation, pagination modules:
// import Swiper, {
//   Navigation,
//   Pagination,
//   Keyboard
// } from 'swiper';
// // import Swiper and modules styles
// // import 'swiper/css';
// // import 'swiper/css/navigation';
// // import 'swiper/css/pagination';

// // configure Swiper to use modules
// Swiper.use([Navigation, Pagination, Keyboard]);

// // init Swiper:
// // eslint-disable-next-line no-unused-vars
// const swiper = new Swiper('.swiper', {
//   // Optional parameters
//   direction: 'horizontal',
//   loop: true,

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination'
//   },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev'
//   },

//   // And if we need scrollbar
//   scrollbar: {
//     el: '.swiper-scrollbar'
//   },
//   keyboard: {
//     enabled: true,
//     onlyInViewport: false
//   }
// });
// // swiper.slideNext();